export default {
  getDefaultState: () => {
    return {
      budgets: [],
      currentBudget: {},
      filters: {},
      currentPage: 1,
      lastPage: 1,
      totalItems: 0,
      isCallingBudgets: false
    }
  }
}
